import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useGetList } from "react-admin";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


const MonthlyPerformanceTable = ({ filter }) => {
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const { data, isLoading, error } = useGetList("dashboardCards&action=monthlyPerformanceWidget", {
        filter,
    });

    useEffect(() => {
        if (!data || data.length === 0) return;

        // Extract dynamic month columns from the first row of data
        const dynamicColumns = Object.keys(data[0])
            .filter((key) => key !== "row_name" && key !== "total_result" && key !== "trend" && key !== "id")
            .map((key) => ({
                field: key,
                renderHeader: (params) => {
                    const yearName = params.field.substring(0, 3);
                    const year = params.field.split("-")[1];
                    return (
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <span>{yearName}</span>
                            <span style={{ fontSize: "0.7rem" }}>{year}</span>
                        </div>
                    );
                },
                flex: 1,
                minWidth: 50,
                type: "number",
                sortable: false,
            }));

        // Map rows to the required format
        const rowData = data.map((item, index) => ({
            id: index, // Use index as ID (ensure unique key)
            ...item,
        }));
        rowData.forEach((rdata) => {
            Object.keys(rdata).forEach((key) => {
                if (rdata[key] === null) {
                    rdata[key] = 0;
                } else {
                    rdata[key] = isNaN(parseFloat(rdata[key])) ? rdata[key] : parseFloat(rdata[key]).toFixed(0);
                }
            });
        });
        setColumns([
            {
                field: "row_name",
                headerName: "no tex",
                width: 150,
                sortable: false,
            },
            ...dynamicColumns,
            {
                field: "total_result",
                headerName: "Total",
                width: 120,
                type: "number",
                sortable: false,
            },
            {
                field: "trend",
                headerName: "Trend (%)",
                width: 120,
                description: "Vergleich des Durchschnitts der letzten 3 Monate mit dem der letzten 6 Monate",
                type: "number",
                sortable: false,
                renderCell: (params) => {
                    const value = parseFloat(params.value || 0).toFixed(2);
                    let color;
                    if (value < 0) {
                        color = "red";
                        return (
                            <span
                                style={{
                                    color,
                                    fontWeight: "light",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                }}
                            >
                                {" "}
                                <div
                                    style={{
                                        width: "21px",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <img style={{ width: "100%" }} src={require("../../images/red_arrow.png")} alt="arrow-icon" />
                                </div>
                                {value}%
                            </span>
                        );
                    } else if (value > 0) {
                        color = "green";
                        return (
                            <span
                                style={{
                                    color,
                                    fontWeight: "light",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    marginLeft: "2px",
                                }}
                            >
                                {" "}
                                <img src={require("../../images/gren-arrow.png")} alt="green-arrow" />
                                {value}%
                            </span>
                        );
                    } else {
                        color = "rgb(214 177 8)";
                        return (
                            <span
                                style={{
                                    color,
                                    fontWeight: "light",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    marginLeft: "2px",
                                }}
                            >
                                <ArrowForwardIcon fontSize="large" sx={{ fontSize: "17px" }}></ArrowForwardIcon>
                                {value}%
                            </span>
                        );
                    }
                },
            },
        ]);

        setRows(rowData);
    }, [data]);

    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Error loading data</div>;

    return (
        <div>
            <DataGrid
                rows={rows}
                columns={columns}
                disableColumnFilter
                density="compact"
                disableColumnSelector
                disableColumnMenu
                pageSizeOptions={[5]}
                autoHeight
                columnHeaderHeight={75}
                sx={{
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#f5f5f5",
                        fontSize: "0.9rem",
                    },
                    "& .MuiDataGrid-footerContainer": {
                        display: "none",
                    },
                }}
            />
        </div>
    );
};

export default MonthlyPerformanceTable;
